module.exports = __webpack_public_path__ + "static/media/pet-date.da5e025e.svg";